import { API_URL } from "../config/config";
import { RequestFn } from "../api/useApi";
import { getBody } from "../helpers/body.helper";
import { toError } from "../helpers/error.helper";
import { buildQuery } from "../helpers/query.helper";
import { IJobCreate } from "../interfaces/job/iJobCreate.interface";
import { JobQueryVM } from "../interfaces/job/iJobQuery.interface";
import { IJobView } from "../interfaces/job/iJobView.interface";

const API_NAME = "job";

export const jobService = {
    getAll,
    get,
    getAllAuthorized,
    put,
    post,
};

async function getAll(query: JobQueryVM) {
    const qs = buildQuery(query);
    const res = await fetch(`${API_URL}/job/getAll?${qs}`, { method: "GET" });
    if (!res.ok) throw await toError(res, "Failed to fetch jobs");
    return res.json();
}

async function getAllAuthorized(request: RequestFn, query: JobQueryVM) {
    const qs = buildQuery(query);
    const res = await request(`${API_URL}/job/GetAllAuthorized?${qs}`, { method: "GET" });
    if (!res.ok) throw await toError(res, "Failed to fetch jobs");
    return res.json();
}

async function get(id: number, request?: RequestFn): Promise<IJobView> {
    const res = request
        ? await request(`${API_URL}/${API_NAME}/Get/?id=${id}`, { method: "GET" })
        : await fetch(`${API_URL}/${API_NAME}/Get/?id=${id}`, { method: "GET" });
    if (!res.ok) throw await toError(res, "Failed to fetch job");
    return res.json();
}

async function post(model: IJobCreate, request: RequestFn) {
    const res = await request(`${API_URL}/${API_NAME}/create`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: getBody(model),
    });
    if (!res.ok) throw await toError(res, "Failed to create job");
    try {
        return await res.json();
    } catch {
        return null;
    }
}

async function put(model: IJobCreate, request: RequestFn) {
    const res = await request(`${API_URL}/${API_NAME}/update`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: getBody(model),
    });
    if (!res.ok) throw await toError(res, "Failed to update job");
    try {
        return await res.json();
    } catch {
        return null;
    }
}
